import { RaceBy } from "@uiball/loaders";
import Flexbox from "../../components/Flexbox";
import Mode from "../../components/styles/Mode";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import requests from "../../handlers/requests";
import '../../css/form.css'
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import { extractUTMParameters } from "../../utilities/utils";
import { useNavigate } from "react-router-dom";

export const Cura = () => {
    const mode = useSelector(state => state.darkmode.value)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)

    const [error,] = useState(null)
    const sendToCura = (id, source, page, stop) => {
        setLoading(true)

        requests.post(`/api/${source}/cura`, { contact_id: id }, () => { }, () => { }, () => { }, setLoading,
            (res) => {
                // send to cura thank you page
                window.location.replace(`https://www.finaldebtrelief.com/success-cura-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}&url=${res.url}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
            },
            null,
            (res) => {
                // handle error

                if (res.error.includes('Duplicated')) {
                    window.location.replace(`https://www.finaldebtrelief.com/dup-error-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                } else if (res.msg === 'Outside valid area') {
                    window.location.replace(`https://www.finaldebtrelief.com/dq-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                } else if (res.msg.includes('Failed')) {
                    window.location.replace(`https://www.finaldebtrelief.com/fd-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                } else {
                    navigate(`/turbo-form-${page}?contact_id=${res.data.contact_id}&firstname=${res.data.first_name}&lastname=${res.data.last_name}&email=${res.data.email}&phone=${res.data.phone}&saved=true&error=Could not complete request. please try again!${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
                }
            }
        )
    }


    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const source = urlParams.get('source')
        const page = urlParams.get('page')

        sendToCura(contact_id, source, page, false)
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="turbo-debt-page">
                {loading && <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                    <RaceBy size={40} speed={0.9} color={mode.dark ? "white" : "black"} />
                </Flexbox>}
                {error && (
                    <div>
                        <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                            {error}
                        </Flexbox>
                    </div>
                )}
            </div>
        </Mode>
    );
}